export const quoteswitchActions = {
    changeMode,
}

function changeMode(mode){
    return dispatch => {
        dispatch({ type: mode });
    }
}